import { supabase } from '../lib/supabase';

export const staffIdEmailService = {
  // ============================================================================
  // STAFF ID APPROVAL EMAIL NOTIFICATIONS
  // ============================================================================

  async sendStaffIdSubmissionEmail(cardData, approverEmails) {
    try {
      const html = `
        <!DOCTYPE html>
        <html>
        <head>
          <style>
            body { font-family: Arial, sans-serif; line-height: 1.6; color: #333; }
            .container { max-width: 600px; margin: 0 auto; padding: 20px; }
            .header { background: #3b82f6; color: white; padding: 20px; text-align: center; }
            .content { padding: 20px; background: #f9fafb; }
            .card-info { background: white; border-left: 4px solid #3b82f6; padding: 15px; margin: 20px 0; border-radius: 4px; }
            .footer { text-align: center; padding: 20px; color: #6b7280; font-size: 12px; }
            .button { display: inline-block; padding: 12px 24px; background: #3b82f6; color: white; text-decoration: none; border-radius: 6px; margin: 10px 0; }
            .info-row { margin: 8px 0; }
            .label { font-weight: 600; color: #4b5563; }
          </style>
        </head>
        <body>
          <div class="container">
            <div class="header">
              <h1>📋 Staff ID Approval Request</h1>
            </div>
            <div class="content">
              <p>Dear Approver,</p>
              <p>A new staff ID card has been submitted for approval and requires your review.</p>
              
              <div class="card-info">
                <h3>Staff ID Details</h3>
                <div class="info-row">
                  <span class="label">Card Number:</span> ${cardData?.cardNumber || 'N/A'}
                </div>
                <div class="info-row">
                  <span class="label">Employee:</span> ${cardData?.employeeName || 'N/A'}
                </div>
                <div class="info-row">
                  <span class="label">Employee Number:</span> ${cardData?.employeeNumber || 'N/A'}
                </div>
                <div class="info-row">
                  <span class="label">Department:</span> ${cardData?.department || 'N/A'}
                </div>
                <div class="info-row">
                  <span class="label">Position:</span> ${cardData?.position || 'N/A'}
                </div>
                <div class="info-row">
                  <span class="label">Submitted By:</span> ${cardData?.submittedBy || 'N/A'}
                </div>
                <div class="info-row">
                  <span class="label">Submitted At:</span> ${cardData?.submittedAt ? new Date(cardData.submittedAt)?.toLocaleString('en-PG') : 'N/A'}
                </div>
                <div class="info-row">
                  <span class="label">Approval Level:</span> ${cardData?.approvalLevel || 'Level 1'}
                </div>
              </div>

              <p><strong>Action Required:</strong></p>
              <p>Please review the staff ID card details and take appropriate action (approve or reject) in the system.</p>

              <a href="${typeof window !== 'undefined' ? window.location?.origin : ''}/staff-id-card-management-center" class="button">Review Approval Request</a>
            </div>
            <div class="footer">
              <p>This is an automated message from PNG HR Management System</p>
              <p>Pacific RBS Ltd | admin@hrpacificrbs.com | +675 78808282</p>
            </div>
          </div>
        </body>
        </html>
      `;

      const { data, error } = await supabase?.functions?.invoke('send-staff-id-approval-email', {
        body: {
          to: approverEmails,
          subject: `📋 Staff ID Approval Request - ${cardData?.employeeName || 'Employee'}`,
          html: html,
          type: 'staff_id_submission',
          metadata: {
            cardId: cardData?.cardId,
            cardNumber: cardData?.cardNumber,
            employeeId: cardData?.employeeId,
            approvalLevel: cardData?.approvalLevel
          }
        }
      });

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error sending staff ID submission email:', error);
      throw error;
    }
  },

  async sendStaffIdApprovalEmail(cardData, recipientEmails, approverName) {
    try {
      const html = `
        <!DOCTYPE html>
        <html>
        <head>
          <style>
            body { font-family: Arial, sans-serif; line-height: 1.6; color: #333; }
            .container { max-width: 600px; margin: 0 auto; padding: 20px; }
            .header { background: #10b981; color: white; padding: 20px; text-align: center; }
            .content { padding: 20px; background: #f9fafb; }
            .card-info { background: white; border-left: 4px solid #10b981; padding: 15px; margin: 20px 0; border-radius: 4px; }
            .footer { text-align: center; padding: 20px; color: #6b7280; font-size: 12px; }
            .button { display: inline-block; padding: 12px 24px; background: #3b82f6; color: white; text-decoration: none; border-radius: 6px; margin: 10px 0; }
            .info-row { margin: 8px 0; }
            .label { font-weight: 600; color: #4b5563; }
            .status-badge { display: inline-block; padding: 4px 12px; background: #d1fae5; color: #065f46; border-radius: 12px; font-size: 14px; font-weight: 600; }
          </style>
        </head>
        <body>
          <div class="container">
            <div class="header">
              <h1>✅ Staff ID Approved</h1>
            </div>
            <div class="content">
              <p>Dear Team,</p>
              <p>A staff ID card has been approved at ${cardData?.approvalLevel || 'approval level'}.</p>
              
              <div class="card-info">
                <h3>Approval Details</h3>
                <div class="info-row">
                  <span class="label">Status:</span> <span class="status-badge">APPROVED</span>
                </div>
                <div class="info-row">
                  <span class="label">Card Number:</span> ${cardData?.cardNumber || 'N/A'}
                </div>
                <div class="info-row">
                  <span class="label">Employee:</span> ${cardData?.employeeName || 'N/A'}
                </div>
                <div class="info-row">
                  <span class="label">Employee Number:</span> ${cardData?.employeeNumber || 'N/A'}
                </div>
                <div class="info-row">
                  <span class="label">Department:</span> ${cardData?.department || 'N/A'}
                </div>
                <div class="info-row">
                  <span class="label">Approved By:</span> ${approverName || 'N/A'}
                </div>
                <div class="info-row">
                  <span class="label">Approved At:</span> ${cardData?.approvedAt ? new Date(cardData.approvedAt)?.toLocaleString('en-PG') : 'N/A'}
                </div>
                <div class="info-row">
                  <span class="label">Approval Level:</span> ${cardData?.approvalLevel || 'N/A'}
                </div>
                ${cardData?.comments ? `
                <div class="info-row">
                  <span class="label">Comments:</span> ${cardData?.comments}
                </div>
                ` : ''}
              </div>

              ${cardData?.isFinalApproval ? `
                <p><strong>🎉 Final Approval Completed!</strong></p>
                <p>This staff ID card has completed all approval levels and is now ready for production.</p>
              ` : `
                <p><strong>Next Steps:</strong></p>
                <p>The approval has been forwarded to the next level for review.</p>
              `}

              <a href="${typeof window !== 'undefined' ? window.location?.origin : ''}/staff-id-card-management-center" class="button">View Staff ID Details</a>
            </div>
            <div class="footer">
              <p>This is an automated message from PNG HR Management System</p>
              <p>Pacific RBS Ltd | admin@hrpacificrbs.com | +675 78808282</p>
            </div>
          </div>
        </body>
        </html>
      `;

      const { data, error } = await supabase?.functions?.invoke('send-staff-id-approval-email', {
        body: {
          to: recipientEmails,
          subject: cardData?.isFinalApproval 
            ? `✅ Staff ID Final Approval - ${cardData?.employeeName || 'Employee'}` 
            : `✅ Staff ID Approved at ${cardData?.approvalLevel || 'Level'} - ${cardData?.employeeName || 'Employee'}`,
          html: html,
          type: 'staff_id_approval',
          metadata: {
            cardId: cardData?.cardId,
            cardNumber: cardData?.cardNumber,
            employeeId: cardData?.employeeId,
            approvalLevel: cardData?.approvalLevel,
            isFinalApproval: cardData?.isFinalApproval
          }
        }
      });

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error sending staff ID approval email:', error);
      throw error;
    }
  },

  async sendStaffIdRejectionEmail(cardData, recipientEmails, rejectorName) {
    try {
      const html = `
        <!DOCTYPE html>
        <html>
        <head>
          <style>
            body { font-family: Arial, sans-serif; line-height: 1.6; color: #333; }
            .container { max-width: 600px; margin: 0 auto; padding: 20px; }
            .header { background: #dc2626; color: white; padding: 20px; text-align: center; }
            .content { padding: 20px; background: #f9fafb; }
            .card-info { background: white; border-left: 4px solid #dc2626; padding: 15px; margin: 20px 0; border-radius: 4px; }
            .rejection-box { background: #fef2f2; border: 1px solid #fecaca; padding: 15px; margin: 20px 0; border-radius: 4px; }
            .footer { text-align: center; padding: 20px; color: #6b7280; font-size: 12px; }
            .button { display: inline-block; padding: 12px 24px; background: #3b82f6; color: white; text-decoration: none; border-radius: 6px; margin: 10px 0; }
            .info-row { margin: 8px 0; }
            .label { font-weight: 600; color: #4b5563; }
            .status-badge { display: inline-block; padding: 4px 12px; background: #fee2e2; color: #991b1b; border-radius: 12px; font-size: 14px; font-weight: 600; }
          </style>
        </head>
        <body>
          <div class="container">
            <div class="header">
              <h1>❌ Staff ID Rejected</h1>
            </div>
            <div class="content">
              <p>Dear Team,</p>
              <p>A staff ID card has been rejected at ${cardData?.approvalLevel || 'approval level'} and requires attention.</p>
              
              <div class="card-info">
                <h3>Rejection Details</h3>
                <div class="info-row">
                  <span class="label">Status:</span> <span class="status-badge">REJECTED</span>
                </div>
                <div class="info-row">
                  <span class="label">Card Number:</span> ${cardData?.cardNumber || 'N/A'}
                </div>
                <div class="info-row">
                  <span class="label">Employee:</span> ${cardData?.employeeName || 'N/A'}
                </div>
                <div class="info-row">
                  <span class="label">Employee Number:</span> ${cardData?.employeeNumber || 'N/A'}
                </div>
                <div class="info-row">
                  <span class="label">Department:</span> ${cardData?.department || 'N/A'}
                </div>
                <div class="info-row">
                  <span class="label">Rejected By:</span> ${rejectorName || 'N/A'}
                </div>
                <div class="info-row">
                  <span class="label">Rejected At:</span> ${cardData?.rejectedAt ? new Date(cardData.rejectedAt)?.toLocaleString('en-PG') : 'N/A'}
                </div>
                <div class="info-row">
                  <span class="label">Approval Level:</span> ${cardData?.approvalLevel || 'N/A'}
                </div>
              </div>

              ${cardData?.rejectionReason ? `
              <div class="rejection-box">
                <h4 style="margin-top: 0; color: #991b1b;">Rejection Reason:</h4>
                <p style="margin-bottom: 0;">${cardData?.rejectionReason}</p>
              </div>
              ` : ''}

              ${cardData?.comments ? `
              <div class="info-row">
                <span class="label">Additional Comments:</span>
                <p>${cardData?.comments}</p>
              </div>
              ` : ''}

              <p><strong>Action Required:</strong></p>
              <p>Please review the rejection reason and make necessary corrections before resubmitting the staff ID card for approval.</p>

              <a href="${typeof window !== 'undefined' ? window.location?.origin : ''}/staff-id-card-management-center" class="button">View and Resubmit</a>
            </div>
            <div class="footer">
              <p>This is an automated message from PNG HR Management System</p>
              <p>Pacific RBS Ltd | admin@hrpacificrbs.com | +675 78808282</p>
            </div>
          </div>
        </body>
        </html>
      `;

      const { data, error } = await supabase?.functions?.invoke('send-staff-id-approval-email', {
        body: {
          to: recipientEmails,
          subject: `❌ Staff ID Rejected at ${cardData?.approvalLevel || 'Level'} - ${cardData?.employeeName || 'Employee'}`,
          html: html,
          type: 'staff_id_rejection',
          metadata: {
            cardId: cardData?.cardId,
            cardNumber: cardData?.cardNumber,
            employeeId: cardData?.employeeId,
            approvalLevel: cardData?.approvalLevel,
            rejectionReason: cardData?.rejectionReason
          }
        }
      });

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error sending staff ID rejection email:', error);
      throw error;
    }
  },

  // ============================================================================
  // HELPER METHODS
  // ============================================================================

  async getApproverEmailsByRole(role) {
    try {
      const { data, error } = await supabase
        ?.from('user_role_assignments')
        ?.select(`
          user_email,
          custom_roles (
            role_name
          )
        `)
        ?.eq('custom_roles.role_name', role)
        ?.eq('is_active', true);

      if (error) throw error;
      return data?.map(row => row?.user_email)?.filter(email => email) || [];
    } catch (error) {
      console.error('Error fetching approver emails by role:', error);
      return [];
    }
  },

  async getEmployeeEmail(employeeId) {
    try {
      const { data, error } = await supabase
        ?.from('employees')
        ?.select('email')
        ?.eq('id', employeeId)
        ?.single();

      if (error) throw error;
      return data?.email || null;
    } catch (error) {
      console.error('Error fetching employee email:', error);
      return null;
    }
  },

  async getSubmitterEmail(submittedBy) {
    try {
      // submittedBy is typically a user email or user ID
      // If it's already an email, return it
      if (submittedBy?.includes('@')) {
        return submittedBy;
      }

      // Otherwise, try to fetch from users table
      const { data, error } = await supabase
        ?.from('users')?.select('email')?.eq('id', submittedBy)
        ?.single();

      if (error) throw error;
      return data?.email || null;
    } catch (error) {
      console.error('Error fetching submitter email:', error);
      return null;
    }
  }
};

export default staffIdEmailService;
